// extracted by mini-css-extract-plugin
module.exports = {"ButtonBox":"style_ButtonBox__bXmp1","PlainButtonBox":"style_PlainButtonBox__3R7Lb","disable":"style_disable__2BPUX"};